"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldStyles = exports.SelectInputField = exports.TextInputField = exports.CheckboxField = exports.Field = void 0;
const Field_pc_1 = require("./Field.pc");
const TextInput_1 = require("./TextInput");
const react_1 = __importStar(require("react"));
const Checkbox_1 = require("./Checkbox");
const nanoid_1 = require("nanoid");
const Select_1 = require("./Select");
const Field = ({ className, children, error, v3, 'data-testid': testId, toggle = false, secondary, spaceBottom, noSpace, disabled = false, value, label, onBlur = () => undefined, infoText, left, onValueChange, name, hidden = false, }) => {
    let subtext = infoText;
    const [internalValue, setValue] = (0, react_1.useState)(value);
    // just need a random ID so that we can assign htmlFor to the label (specific to checkbox toggling)
    const [inputId] = (0, react_1.useState)(nanoid_1.nanoid);
    (0, react_1.useEffect)(() => {
        setValue(value);
    }, [value]);
    if (error) {
        subtext = react_1.default.createElement("span", null, error);
    }
    const onValueChange2 = (value) => {
        setValue(value);
        onValueChange && onValueChange(value);
    };
    const [isActive, setActive] = (0, react_1.useState)(false);
    const onFocusIn = (0, react_1.useCallback)(() => {
        setActive(true);
    }, [setActive]);
    const onFocusOut = (0, react_1.useCallback)(() => {
        setActive(false);
    }, [setActive]);
    return (react_1.default.createElement(Field_pc_1.Field, { secondary: secondary, className: className, noSpace: noSpace, spaceBottom: spaceBottom, negative: Boolean(error), htmlFor: inputId, toggle: toggle, label: label, v3: v3, testId: testId, left: left, subtext: subtext, active: isActive || internalValue || internalValue === 0, onFocus: onFocusIn, onBlur: onFocusOut, hidden: hidden }, children({
        value: internalValue,
        id: inputId,
        name,
        disabled,
        onBlur,
        onValueChange: onValueChange2,
    })));
};
exports.Field = Field;
const CheckboxField = (_a) => {
    var { inputTestId } = _a, rest = __rest(_a, ["inputTestId"]);
    return (react_1.default.createElement(exports.Field, Object.assign({ v3: true }, rest, { toggle: true }), (inputProps) => react_1.default.createElement(Checkbox_1.Checkbox, Object.assign({}, inputProps, { testId: inputTestId }))));
};
exports.CheckboxField = CheckboxField;
const TextInputField = (_a) => {
    var { inputMode, inputTestId, autoFocus, placeholder, disabled } = _a, rest = __rest(_a, ["inputMode", "inputTestId", "autoFocus", "placeholder", "disabled"]);
    return (react_1.default.createElement(exports.Field, Object.assign({ v3: true }, rest), (inputProps) => (react_1.default.createElement(TextInput_1.TextInput, Object.assign({}, inputProps, { disabled: disabled, placeholder: placeholder, autoFocus: autoFocus, "data-testid": inputTestId, inputMode: inputMode })))));
};
exports.TextInputField = TextInputField;
const SelectInputField = (_a) => {
    var { inputTestId, inputAriaLabel, options, isMulti, isMultiClearable, isClearable, isCreatable, placeholder = '', menuPlacement } = _a, rest = __rest(_a, ["inputTestId", "inputAriaLabel", "options", "isMulti", "isMultiClearable", "isClearable", "isCreatable", "placeholder", "menuPlacement"]);
    return (react_1.default.createElement(exports.Field, Object.assign({ v3: true }, rest), (inputProps) => (react_1.default.createElement(Select_1.SelectInput, Object.assign({}, inputProps, { options: options, placeholder: placeholder, isMulti: isMulti, isClearable: isClearable, isCreatable: isCreatable, isMultiClearable: isMultiClearable, "aria-label": inputAriaLabel, "data-testid": inputTestId, menuPlacement: menuPlacement })))));
};
exports.SelectInputField = SelectInputField;
exports.FieldStyles = Field_pc_1.Field;
//# sourceMappingURL=Field.js.map